import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ScrollArea } from "@mantine/core";
import { LayerConfigHeader } from "./LayerConfigHeader.js";
import { LayerConfigControls } from "./LayerConfigControls.js";
import { LayerDataSource } from "./LayerDataSource.js";
import { SecondaryPanel } from "../../components/SidePanel.js";
export const LayerConfigData = ({ layer, sourceLayerId, sourceInfo }) => {
    return (_jsxs(SecondaryPanel, { children: [_jsx(LayerConfigHeader, { layer: layer }), _jsx(LayerConfigControls, { layer: layer }), _jsx(ScrollArea, { h: "calc(100% - 100px)", children: _jsx(LayerDataSource, { layer: layer, sourceLayerId: sourceLayerId, sourceInfo: sourceInfo }) })] }));
};
